import { classes } from "handlers/StyleHandler";
import { setLanguage } from "i18n";
import { useAppContext } from "providers/ContextProvider";
import React from "react";
import { useTranslation } from "react-i18next";
import s from "./footer.module.scss";

const Footer: React.FC = () => {
  const { showPoweredBy, hideLanguageSelector } = useAppContext();
  const { t, i18n } = useTranslation();

  const activeLanguage = i18n.language && i18n.language.slice(0, 2);

  return (
    <footer className={s.footer}>
      {!hideLanguageSelector && (
        <div className={s.lang}>
          <button
            aria-label="English"
            onClick={() => setLanguage("en")}
            className={classes(
              s.langButton,
              activeLanguage === "en" ? s.active : ""
            )}
          >
            🇬🇧
          </button>
          <button
            aria-label="Deutsch"
            onClick={() => setLanguage("de")}
            className={classes(
              s.langButton,
              activeLanguage === "de" ? s.active : ""
            )}
          >
            🇩🇪
          </button>
          <button
            aria-label="Italiano"
            onClick={() => setLanguage("it")}
            className={classes(
              s.langButton,
              activeLanguage === "it" ? s.active : ""
            )}
          >
            🇮🇹
          </button>
          <button
            aria-label="Français"
            onClick={() => setLanguage("fr")}
            className={classes(
              s.langButton,
              activeLanguage === "fr" ? s.active : ""
            )}
          >
            🇫🇷
          </button>
        </div>
      )}
      {showPoweredBy && (
        <p>
          {t("footer.poweredBy")}{" "}
          <a
            className={s.link}
            href="https://www.copetence.de?utm_source=cp_ticketing&utm_medium=referral"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("footer.brand")}
          </a>
        </p>
      )}
    </footer>
  );
};

export default Footer;
